import React, { useState, useEffect } from 'react';
import Spinner from '../components/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { api } from '../services/api';
import { useNotification } from '../components/Notification';
import { getCurrencySymbol } from '../utils/currency';
import './HourlyRates.css';
import './DetailPages.css';

function HourlyRateDetail({ tenantId }) {
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { id } = useParams();
  const [rate, setRate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tenant, setTenant] = useState(null);

  useEffect(() => {
    if (tenantId && id) {
      loadData();
    }
  }, [tenantId, id]);

  const loadData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        loadTenant(),
        loadRate()
      ]);
    } finally {
      setLoading(false);
    }
  };

  const loadTenant = async () => {
    try {
      const data = await api.get('/tenants', null);
      const currentTenant = data.find(t => t.id === tenantId) || data[0];
      setTenant(currentTenant);
    } catch (error) {
      console.error('Error loading tenant:', error);
    }
  };

  const currency = getCurrencySymbol(tenant?.taxSystem || 'DE');

  const loadRate = async () => {
    try {
      const data = await api.get(`/hourly-rates/${id}`, tenantId);
      setRate(data);
    } catch (error) {
      console.error('Error loading rate:', error);
      showNotification('Fehler beim Laden des Stundensatzes', 'error');
      navigate('/hourly-rates');
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: currency === 'CHF' ? 'CHF' : 'EUR',
      minimumFractionDigits: 2
    }).format(amount);
  };

  if (loading) {
    return <Spinner />;
  }

  if (!rate) {
    return <div>Stundensatz nicht gefunden</div>;
  }

  return (
    <div className="rate-detail">
      <div className="detail-header">
        <button type="button" onClick={() => navigate('/hourly-rates')} className="btn-secondary">
          ← Zurück
        </button>
        <h1>{rate.name}</h1>
        <button type="button" onClick={() => navigate(`/hourly-rates/${id}/edit`)} className="btn-primary">
          Bearbeiten
        </button>
      </div>

      <div className="detail-section">
        <h2>Informationen</h2>
        <p><strong>Stundensatz:</strong> {formatCurrency(rate.rate)}/h</p>
        {rate.description && <p><strong>Beschreibung:</strong> {rate.description}</p>}
        <p><strong>Standard:</strong> {rate.isDefault ? 'Ja' : 'Nein'}</p>
      </div>
    </div>
  );
}

export default HourlyRateDetail;

